import { qualifyUrls } from "routing/Routes";
const HealthRoutes = {
  OVERVIEW: "/system/health"
};
const routes = qualifyUrls(HealthRoutes);
export default {
  ...routes,
  unqualified: HealthRoutes
};
